<mini-widget-icon-card
    [color]="(isInsideThreshold$ | async) ? 'success' : (isTemperatureInsideThreshold$ | async) ? 'danger' : 'failure'"
    [iconImage]="
        (isInsideThreshold$ | async)
            ? 'assets/icons/smiley_happy.svg'
            : (isTemperatureInsideThreshold$ | async)
              ? 'assets/icons/smiley_neutral.svg'
              : 'assets/icons/smiley_sad.svg'
    "
    [isLoading]="loading$ | async"
    [clickable]="true"
    (click)="goToAnalysisPage()"
>
    <div class="text-content">
        <div class="display-flex space-between card-title">
            <edit-text
                [disabled]="!(tileConfig.hasTileAdminAccess$ | async)"
                [(ngModel)]="tileData.name"
                (ngModelChange)="updateTileName()"
            />
            <div class="settings">
                @if (tileConfig.hasTileAdminAccess$ | async) {
                    <ui-icon-button iconName="delete" size="small" (click)="deleteTile($event)" />
                }
            </div>
        </div>
        <div class="main-content">
            <h1 [coloredTextColor]="(isTemperatureInsideThreshold$ | async) ? 'success' : 'failure'">
                <span class="main-value">{{ (temperatureSensor$ | async)?.lastPoint?.value | significantDigits | localnumber }}</span>
                <span class="main-unit">{{ temperatureUnit | referenceListLabel: 'unit' }}</span>
            </h1>
            @if ((humiditySensor$ | async)?.lastPoint?.value; as humiditySensorValue) {
                <h1 [coloredTextColor]="(isHumidityInsideThreshold$ | async) ? 'success' : 'failure'">
                    <span class="secondary-value">
                        &nbsp; ({{ humiditySensorValue | significantDigits | localnumber
                        }}<span class="secondary-unit">{{ 'STUFF.RELATIVE_HUMIDITY' | translate }}</span
                        >)
                    </span>
                </h1>
            }
        </div>
        @if (isInsideThreshold$ | async) {
            <p class="sub-content">{{ 'TILES.COMFORT.VALID' | translate }}</p>
        } @else {
            <p class="sub-content">{{ 'TILES.COMFORT.INVALID' | translate }}</p>
        }
    </div>
</mini-widget-icon-card>
